<div class="animate-fade-in flex items-center justify-center">
  <div class="animate-fade-in flex flex-col items-center justify-center gap-8">
    <app-lottie-animation
      animationName="page_404"
      height="380px"
      width="380px" />
    <p class="text-2xl font-bold text-content-secondary">
      Oops! Não há nada aqui.
    </p>
    <p class="text-center text-base text-gray-400">
      O recurso que você está procurando, não foi encontrado.
    </p>
    <button (click)="onBack()" appButton variant="outline">Voltar</button>
  </div>
</div>
